import Accordian, { AccordianProps } from './Accordian'
export default Accordian
export { Accordian }
export type { AccordianProps }
